import { createSelector } from '@ngrx/store';
import { PayRuleStore } from '../reducers/payment-rules.reducer';

export const selectPreAuthorizedDebitMode = createSelector(
  PayRuleStore,
  (state) => state?.preAuthorizedDebitMode,
);
